import React from 'react'
// components
import ReportContainer from 'containers/Report'

const ReportPage: React.FC = () => <ReportContainer />

export default ReportPage
